import classNames from 'classnames'
import React, {
  Dispatch,
  PropsWithChildren,
  SetStateAction,
  useEffect,
  useState,
} from 'react'
import { isMobile } from 'react-device-detect'

interface ForthStepProps {
  voiceName: string
  setVoiceName: Dispatch<SetStateAction<string>>
  setBtnLabel: Dispatch<SetStateAction<string>>
}
export const ForthStep = ({
  voiceName,
  setVoiceName,
  setBtnLabel,
}: PropsWithChildren<ForthStepProps>) => {
  const PRODUCT_NAME_PATTERN = /^[^<>\uD800-\uDFFF]*$/

  const handleVoiceName = (e: any) => {
    const name = e.target.value
    setVoiceName(name)
  }

  useEffect(() => {
    setBtnLabel('내 목소리 만들기 시작!')
  }, [])
  return (
    <div className="text-center space-y-6 md:h-[450px]">
      <div
        className={classNames(
          'px-4 py-5 text-left bg-[#F6F8FB]  rounded-[10px] flex   gap-3',
          {
            'flex-col items-start justify-start ': isMobile,
            'items-center': !isMobile,
          }
        )}
      >
        <p className="text-[44px] text-left">🎉</p>
        <div className="flex flex-col gap-2">
          <p className="font-bold text-[20px]">
            내 목소리 생성에 3분 정도 걸립니다.
          </p>
          <p>생성이 완료되면 목소리 선택 목록에서 확인하실 수 있어요!</p>
        </div>
      </div>
      <div className="flex flex-col gap-2 items-start">
        <p className="font-bold text-[20px]">내 목소리의 이름을 정해주세요.</p>
        <input
          className={classNames(
            'w-[343px] text-base md:w-[736px] border-[1px] rounded-[5px] p-[16px]',
            {}
          )}
          onChange={(e) => {
            handleVoiceName(e)
          }}
        />
        <span
          className={classNames('text-[#8F929B]', {
            'text-error':
              voiceName.length > 20 || !PRODUCT_NAME_PATTERN.test(voiceName),
          })}
        >{`이모지와 꺽쇠괄호(< >)는 허용되지 않습니다`}</span>
      </div>
    </div>
  )
}
